import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetHeader, BottomSheetHeaderTitle, Flex, FlexColumn, Separator } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { ActionTimelineSkeleton } from "../../../components/ActionTimeline/ActionTimelineSkeleton";
import { ReceiptDisplaySkeleton } from "../../../components/Receipt";
export function MintFlowSkeleton() {
  const $ = _c(9);
  const t = useTranslations("wallet.MintFlowSkeleton");
  let t0;
  if ($[0] !== t) {
    t0 = t("mint");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <BottomSheetHeader><BottomSheetHeaderTitle>{t0}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ReceiptDisplaySkeleton />;
    t3 = <Separator className="hidden h-auto md:block" orientation="vertical" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BottomSheetBody><Flex className="size-full flex-col gap-6 md:flex-row md:gap-10">{t2}{t3}<FlexColumn className="w-full min-w-0 justify-end"><ActionTimelineSkeleton /></FlexColumn></Flex></BottomSheetBody>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1) {
    t5 = <>{t1}{t4}</>;
    $[7] = t1;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}